// extracted by mini-css-extract-plugin
module.exports = {"text":"Logo_text__HjKl8"};